import {createContext} from "react";

export default createContext({
	loading: false,
	createPurchaseOrderChangeLog: async () => {},
	dispatch: () => {}
});
